'use strict';

var _extends = require('./extends-733dd656.js');
var objectWithoutProperties = require('./objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('./index-7124f64c.js');
var components_NuDSProvider_NuDSProvider = require('./components/NuDSProvider/NuDSProvider.js');
var utils_intl_intlAriaAttrs = require('./utils/intl/intlAriaAttrs.js');
var utils_ref_refType = require('./utils/ref/refType.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function withIntlAriaAttrs(Component) {
  var EnhancedComponent = function EnhancedComponent(props) {
    var intlAriaKey = props.intlAriaKey,
        forwardedRef = props.forwardedRef,
        otherProps = objectWithoutProperties.objectWithoutProperties(props, ["intlAriaKey", "forwardedRef"]);

    var nudsContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext);
    return /*#__PURE__*/React__default['default'].createElement(Component, _extends._extends_1({}, utils_intl_intlAriaAttrs['default'](nudsContext, intlAriaKey), otherProps, {
      ref: forwardedRef
    }));
  };

  EnhancedComponent.defaultProps = {
    forwardedRef: undefined,
    intlAriaKey: ''
  };
  EnhancedComponent.propTypes = {
    forwardedRef: utils_ref_refType['default'],
    intlAriaKey: index.propTypes.string
  };

  function forwardRef(props, ref) {
    return /*#__PURE__*/React__default['default'].createElement(EnhancedComponent, _extends._extends_1({}, props, {
      forwardedRef: ref
    }));
  }

  var name = Component.displayName || Component.name;

  if (name) {
    forwardRef.displayName = "withIntlAriaAttrs(".concat(name, ")");
  }

  return /*#__PURE__*/React__default['default'].forwardRef(forwardRef);
}

exports.withIntlAriaAttrs = withIntlAriaAttrs;
//# sourceMappingURL=withIntlAriaAttrs-d3af74a8.js.map
